import React from 'react';
import ReportSegments from '../../../ReportSegments/ReportSegments';
import ReportByUTMComponent from '../../../../utils/ReportByUTMComponent/ReportByUTMComponent';
import { statisticsByUTM } from '../../../../config';

// Filter (segment) rows of the page: the shared ReportSegments with this page's report params and translations
export const StatisticsByUTMSegments = (props) => (
    <ReportSegments
        {...props}
        segmentKeys={(statisticsByUTM && statisticsByUTM.groupParamsSegment) || []}
        reportComponent={ReportByUTMComponent}
        translationKey="statisticsByUTM"
    />
);

export default StatisticsByUTMSegments;
